import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import { withTranslation } from 'react-i18next'

const ToolbarMenuItem = ({ uiStore, icon = null, title = '', children, menuType, isFlex = false, className = '' }) => {
  const toggleMenuItem = (e, item) => {
    e.stopPropagation()
    if (uiStore.toolbarSelectedMenu === item) {
      uiStore.closeToolbarMenu()
    } else {
      uiStore.setToolbarMenu(item)
    }
  }

  const subItems = children ? (Array.isArray(children) ? children : [children]) : []

  return (
    <li className='toolbar__item' key={menuType}>
      <button
        type='button'
        className={classnames('toolbar__btn', className, {
          active: uiStore.toolbarSelectedMenu === menuType
        })}
        onClick={(e) => toggleMenuItem(e, menuType)}
      >
        {icon && icon}
        {title && <span className='toolbar__btn-text'>{title}</span>}
      </button>
      {uiStore.toolbarSelectedMenu === menuType && (
        <ul className='toolbar__sublist' onClick={(e) => e.stopPropagation()}>
          {subItems.map((child, index) => (
            <li
              key={`${menuType}-${index}`}
              className={classnames('toolbar__sublist-item', { 'toolbar__sublist-item--flex': isFlex })}
            >
              {child}
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}

export default withTranslation()(inject('uiStore')(observer(ToolbarMenuItem)))
